import React, { useState, useEffect, useRef } from 'react'

import { useDispatch, useSelector, shallowEqual } from 'react-redux'


import { Table, Tooltip,Tag,Form, Input, Button, Space,Modal,Descriptions,Divider,
  Statistic, Col,Popconfirm,Collapse,Select,DatePicker, 
  TimePicker,Checkbox, message} from 'antd';
import {   
    MenuUnfoldOutlined,
    MenuFoldOutlined,
    UserOutlined,
    VideoCameraOutlined,
    UploadOutlined, 
    DeploymentUnitOutlined,
    SearchOutlined,
    EditOutlined,
    PlusOutlined
} from '@ant-design/icons';

import './styles.scss'

import moment from 'moment'
import {getData,editItem,addItem,deleteItem,setItem} from '../../../Redux/actions/crudActions'
import {addNewInventory,createLog} from '../../../Redux/actions/inventoryActions'

import {errorParser} from '../../../utils/helpers'

import CreateForm from '../../Generic/CreateForm'
import ProductPriceChange from '../ProductPriceChange'
import ProductInventoryTable from '../ProductInventoryTable'


const { RangePicker } = DatePicker;
const { Panel } = Collapse;
const { Option } = Select;

const Index = ({currentItem,onModalClose,currentProduct}) => { 
    
    const dispatch = useDispatch()    
    const { user } = useSelector(state => ({
      user: state.auth.user,
    }), shallowEqual)

    const [isModalVisible, setIsModalVisible] = useState(false); 



    const [loading, setLoading] = useState(false)   
    const [formSubmitClick, setFormSubmitClick] = useState(false)
    const [somethingChanged, setSomethingChanged] = useState(false)

    var InventoryBlueprint =[
      {
        title: 'Quantity',
        key: 'quantity',
        type: 'quantity', 
        suffix:currentProduct.unit? currentProduct.unit :false, 
        currentProduct:currentProduct,
        rules:{
          required:true   
        }     
      },
      {
        title: 'Restock Level',
        key: 'restock',
        type: 'number',    
      },
      {
        title: 'Reason',
        key: 'reason',  
        type: 'fixed-options',
        choices:[
          { value: 'recount', label: 'Recount - change quantity' },
          { value: 'restock', label: 'Restock - add quantity' },   
          { value: 'spoilage', label: 'Spoilage - subtract quantity' },  
          { value: 'usage', label: 'Use item - subtract quantity' },  
        ],
        rules:{
          required:true   
        }  
            
      },

    ]

    




    useEffect(() => {

    },[currentItem]);





    
    const footer = () =>{
      return(
        <div>
          <Button type="primary" loading={loading} onClick={()=>{setFormSubmitClick(true)}} >
          {false ? 'Create': 'Save Changes'}
          </Button>  
        </div>
      )
     
    }
    const saveChanges = (form) =>{
   
      setLoading(true)
      if(form.errorFields){
        form.errorFields.map(er=>{
          er.errors.map(err=>{
            message.error(err)
          })
        })
        setLoading(false)        
      }else{

        var formData ={
          ...form,
        }
        Object.keys(formData).forEach(key => formData[key] === undefined ? delete formData[key] : {});
    
        var form_data = {};
        
        Object.entries(formData).map(([key, value]) =>{ 
      
          var newval = value
          
          if(Array.isArray(value)){
            if(newval.length == 0){
              newval = []
  
            }
        
          }
          form_data[key] = newval;
        })
        var newcurrentItem = {...currentItem}
        delete newcurrentItem.id;
        var updated_at = moment().format('YYYY-MM-DD HH:mm:ss')
        var updated_by = user.id
        var updated_name = user.name
        var newform ={
          ...newcurrentItem,
          ...form_data,
          updated_at,
          updated_by,
          updated_name
        }
        if(!newform.restock){
          newform['restock'] = 0
        }
        if(form_data.reason == 'restock'){
          newform['quantity'] = parseFloat(form_data.quantity) + parseFloat(newcurrentItem.quantity)
        }

        if(form_data.reason == 'spoilage' || form_data.reason == 'usage'){
         
          if(parseFloat(newcurrentItem.quantity) >= parseFloat(form_data.quantity) ){
            newform['quantity'] = parseFloat(newcurrentItem.quantity) - parseFloat(form_data.quantity)
          }else{
            newform['quantity'] = 0
          }
     
        }
        console.log('newform',newform.quantity)
        delete newform.doRestock
        if( currentItem.id == null){
          var created_at = moment().format('YYYY-MM-DD HH:mm:ss')
          newform['created_at'] = created_at;
          var newID = `${newform.location}_${newform.product}`
          var firbaseedoc = dispatch(addNewInventory(newID))  
          firbaseedoc.set(newform)
          .then(res=>{     
            setSomethingChanged(true)
            createInventoryLog(newform,newID)
          })
          .catch((err)=>{    
            var formattedErr = errorParser(err.response)       
            if(typeof formattedErr == 'object' ||  typeof formattedErr == 'array'){
              formattedErr.map(er=>{message.error(er)})
            }else{
              message.error(formattedErr)              
            }
            setLoading(false)
          })
        }else{
    
          dispatch(editItem(newform,'inventory',currentItem.id))
          .then(res=>{ 
       
            createInventoryLog(newform,currentItem.id)
          })
          .catch((err)=>{  
      
            var formattedErr = errorParser(err.response)       
            if(typeof formattedErr == 'object' ||  typeof formattedErr == 'array'){
              formattedErr.map(er=>{message.error(er)})
            }else{
              message.error(formattedErr)              
            }
            setLoading(false)
          })
        }
      }  
  }

    const createInventoryLog = (newform,itemID) =>{
    
      var logEntry ={
        quantity: newform.quantity,
        reason: newform.reason,
        restock: newform.restock,
        created_at: newform.updated_at,
        created_by: newform.updated_by,
        created_name: newform.updated_name,
      }
      dispatch(createLog(logEntry,itemID))
      .then(res=>{     
        updateProduct(newform)
      })
      .catch((err)=>{    
        
        var formattedErr = errorParser(err.response)       
        if(typeof formattedErr == 'object' ||  typeof formattedErr == 'array'){
          formattedErr.map(er=>{message.error(er)})
        }else{
          message.error(formattedErr)              
        }
        setLoading(false)
      })
    }

    const updateProduct = (newform) =>{
      var mergetorproduct = {
        updated_at: newform.updated_at,
        updated_by: newform.updated_by,
        updated_name:newform.updated_name,  
        
      }
      mergetorproduct[`${newform.location}_count`] =  newform.quantity
      mergetorproduct[`${newform.location}_restock`] =  newform.restock

      dispatch(setItem(mergetorproduct,'products',currentItem.product))
      .then(res=>{             
         
        message.success('Item Created')
        closeModal('refresh')
        setLoading(false)
      })
      .catch((err)=>{    
        var formattedErr = errorParser(err.response)       
        if(typeof formattedErr == 'object' ||  typeof formattedErr == 'array'){
          formattedErr.map(er=>{message.error(er)})
        }else{
          message.error(formattedErr)              
        }
        setLoading(false)
      })

    }

    const closeModal = (action) =>{
      if(!loading){
 
        
        setIsModalVisible(false);       
        if(somethingChanged){
          onModalClose('refresh');
        }else{
          onModalClose(action);
        }
        setSomethingChanged(false)
      }
    }

    return(       
      <>
      <div className={"addeditbutton"}>
        <Button  type="primary" icon={<EditOutlined />} onClick={()=>{setIsModalVisible(true); setLoading(false)}} >{`Edit`}</Button>  
        
      </div>

      {isModalVisible?  
        <Modal title={`${currentItem.location_name} - ${currentItem.product_name}`}  visible={isModalVisible} footer={footer()} onCancel={()=>{closeModal()}}>
          <div className="productaddedit-content">
          
            {currentItem ? 
                <CreateForm  currentItem={currentItem}  blueprint={InventoryBlueprint} saveForm={(e)=>{saveChanges(e); setFormSubmitClick(false)}} FormSubmitClick={formSubmitClick} /> 
            :null}
          
          </div>
        </Modal>
        :null}
      </>
    )
}
  
export default Index
  